<script>
/**
 * 新闻与展会（自 vancheen-b2b 的 NewsView.vue 移植为 Vue 2 版本）
 * 结构：page-hero → 新闻卡片栅格 → CTA
 */
import NhShell from '../components/NhShell.vue'
import NhCtaBand from '../components/NhCtaBand.vue'
import NhNewsCard from '../components/NhNewsCard.vue'
import NhPageHero from '../components/NhPageHero.vue'
import { getSite } from '../nh-site-data'
import { t, setPageTitle } from '../nh-i18n'

export default {
  name: 'NhNewsPage',
  components: { NhShell, NhCtaBand, NhNewsCard, NhPageHero },
  computed: {
    NEWS() {
      return getSite('NEWS')
    },
    CTA_NEWS() {
      const cta = getSite('CTA')
      return cta ? cta.news : { title: '', desc: '', actions: [] }
    }
  },
  mounted() {
    setPageTitle('news')
  },
  methods: {
    t
  }
}
</script>

<template>
  <NhShell>
    <NhPageHero
      :crumbs="[{ label: t('crumbs.home'), to: '/' }, { label: t('news.crumb') }]"
      :title="t('news.title')"
      :desc="t('news.desc')"
    />

    <!-- ===== 新闻列表 ===== -->
    <section class="section">
      <div class="container">
        <div class="news-grid">
          <NhNewsCard
            v-for="(item, i) in NEWS"
            :key="item.title"
            :item="item"
            :delay="i % 3 || undefined"
          />
        </div>
      </div>
    </section>

    <!-- ===== CTA ===== -->
    <NhCtaBand
      :title="CTA_NEWS.title"
      :desc="CTA_NEWS.desc"
      :actions="CTA_NEWS.actions"
    />
  </NhShell>
</template>
